import Head from "next/head"
import { Card } from 'react-bootstrap'
import HtmlText from 'atoms/html-text'
import ExternalCssSheet from "atoms/external-css-sheet"

export default function SuccessItems({
  title,
  articles,
}) {
  return (
    <div>
      <ExternalCssSheet
        uniqueKey="lwtoc-css"
        href={`${process.env.NEXT_PUBLIC_API_URL}/wp-content/plugins/luckywp-table-of-contents/front/assets/main.min.css?ver=2.1.4`}
      />
      <Card>
        <Card.Header>{ title }</Card.Header>
        <Card.Body className="p-0">
          <div className="lwptoc lwptoc-autoWidth lwptoc-baseItems lwptoc-inherit" data-smooth-scroll="1" data-smooth-scroll-offset="150" data-lwptoc-initialized="1">
            <div className="lwptoc_i">
              <div className="lwptoc_items lwptoc_items-visible">
                <div className="lwptoc_itemWrap">
                  {articles?.length > 0 && articles.map(result => {
                    return (
                      <div className="lwptoc_item">    
                        <a href={`/succesverhaal/${result.slug}`}>
                          <span className="lwptoc_item_label" dangerouslySetInnerHTML={{__html: result.title.rendered}} />
                        </a>
                      </div>
                    )
                  })} 
                </div>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

